import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const goHome = () => {
  location.href = '/'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["header", _ctx.$route.path.includes('_h5') && 'header_h5'])
  }, [
    _createElementVNode("img", {
      class: "logo",
      onClick: goHome,
      src: "https://static-s.theckb.com/BusinessMarket/SEO/logo.png",
      alt: ""
    })
  ], 2))
}
}

})